export default "__VITE_ASSET__yX18LutV__"